import type { CardLabels } from '@/types/packageCard';

export const DEFAULT_LABELS: CardLabels = {
  badge: {
    styles: { p: 'md:text-sm text-xs font-bold text-theme-brand-blue' },
  },
  title: {
    styles: { p: 'mt-2 md:text-[22px] text-lg font-bold text-text-strong' },
  },
  subtitle: {
    styles: { p: 'mt-1 text-sm font-regular text-text-muted-medium' },
  },
  testsCount: {
    styles: { p: 'text-base font-regular text-text-muted-medium' },
  },
  itemCountLabel: {
    content: 'Tests',
  },
  referralLabel: {
    content: 'Referral',
    styles: { p: 'text-base text-theme-brand-blue font-semibold' },
  },
  testTypeValue: {
    styles: { p: 'text-sm font-semibold text-text-muted-medium' },
  },
  genderLabel: {
    content: 'Gender',
    styles: { p: 'text-base text-theme-brand-blue font-semibold uppercase' },
  },
  genderValue: {
    styles: { p: 'text-sm font-semibold text-text-muted-medium' },
  },
  includedTestsLabel: {
    content: 'Included Tests',
    styles: { p: 'text-lg text-theme-brand-blue font-semibold ml-2' },
  },
  text4: { styles: { p: 'font-semibold text-text-muted-medium mt-3' } },
  descriptionText: { styles: { p: 'text-text-list text-base font-regular' } },
  disclaimer: {
    styles: {
      p: 'mt-1 rounded-md border-l-4 border-surface-button bg-[#F4F6FB] p-3 text-sm text-text-muted',
    },
  },
  price: {
    styles: { p: 'text-[26px] font-bold text-theme-primary whitespace-nowrap' },
  },
  priceLabel: {
    content: '',
  },
  enquireLabel: {
    content: 'Enquire Now',
    styles: {
      p: 'px-7 text-base rounded-lg py-4 cursor-pointer bg-theme-primary text-white font-normal',
    },
  },
  bookLabel: {
    content: 'Book Now',
  },
  expandLabel: {
    content: 'View All',
  },
  collapseLabel: {
    content: 'View Less',
  },
};

export function resolveLabels(overrides?: CardLabels): CardLabels {
  return {
    badge: overrides?.badge ?? DEFAULT_LABELS.badge,
    title: overrides?.title ?? DEFAULT_LABELS.title,
    subtitle: overrides?.subtitle ?? DEFAULT_LABELS.subtitle,
    testsCount: overrides?.testsCount ?? DEFAULT_LABELS.testsCount,
    itemCountLabel: overrides?.itemCountLabel ?? DEFAULT_LABELS.itemCountLabel,
    referralLabel: overrides?.referralLabel ?? DEFAULT_LABELS.referralLabel,
    testTypeValue: overrides?.testTypeValue ?? DEFAULT_LABELS.testTypeValue,
    genderLabel: overrides?.genderLabel ?? DEFAULT_LABELS.genderLabel,
    genderValue: overrides?.genderValue ?? DEFAULT_LABELS.genderValue,
    includedTestsLabel:
      overrides?.includedTestsLabel ?? DEFAULT_LABELS.includedTestsLabel,
    text4: overrides?.text4 ?? DEFAULT_LABELS.text4,
    descriptionText:
      overrides?.descriptionText ?? DEFAULT_LABELS.descriptionText,
    disclaimer: overrides?.disclaimer ?? DEFAULT_LABELS.disclaimer,
    price: overrides?.price ?? DEFAULT_LABELS.price,
    priceLabel: overrides?.priceLabel ?? DEFAULT_LABELS.priceLabel,
    enquireLabel: overrides?.enquireLabel ?? DEFAULT_LABELS.enquireLabel,
    bookLabel: overrides?.bookLabel ?? DEFAULT_LABELS.bookLabel,
    expandLabel: overrides?.expandLabel ?? DEFAULT_LABELS.expandLabel,
    collapseLabel: overrides?.collapseLabel ?? DEFAULT_LABELS.collapseLabel,
  };
}
